/*eslint-disable no-undef,no-redeclare,no-empty */
import April from '../../ALizard/April'

export default ()=>{
    April.define("log.add-buff", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
            var ch = args.scene.member[args.player];
            if(!ch.buff[args.buff]){
                ch.addBuff({RID:args.buff}.$safe(args));
            }
        }else if(args.opr == 'back'){
            var ch = args.scene.member[args.player];
            if(ch.buff[args.buff]){
                ch.removeBuff({RID:args.buff}.$safe(args));
            }
        }else if(args.opr == 'play'){
            var scene=args.scene;
            var ch = args.scene.member[args.player];
            scene.flare("act_console", { value: "call DisplayComponent/buff.add", args: args });
            args.tweener
                .call(function(_args){
                    if(!ch.buff[_args.buff]){
                        ch.addBuff({RID:_args.buff}.$safe(_args));
                    }
                }, null, [args]);
    //        	.wait(1000);
        }
    });
    April.define("log.remove-buff", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
            var ch = args.scene.member[args.player];
            if(ch.buff[args.buff]){
                ch.removeBuff({RID:args.buff}.$safe(args));
            }
        }else if(args.opr == 'back'){
            var ch = args.scene.member[args.player];
            if(!ch.buff[args.buff]){
                ch.addBuff({RID:args.buff}.$safe(args));
            }
        }else if(args.opr == 'play'){
            var scene=args.scene;
            var ch = args.scene.member[args.player];
            scene.flare("act_console", { value: "call DisplayComponent/buff.remove", args: args });
            args.tweener
                .call(function(_args){
                    if(ch.buff[args.buff]){
                        ch.removeBuff({RID:_args.buff}.$safe(_args));
                    }
                }, null, [args]);
        }
    });    
    April.define("log.status", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
        }else if(args.opr == 'back'){
        }else if(args.opr == 'play'){
            var scene=args.scene;
            // var ch = args.scene.member[args.player];
            scene.flare("act_console", { value: "call status", args: args });
            // args.tweener
            //     .call(function(_args){

            //     }, null, [args]);
        }
    });    
    April.define("log.barrier", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
        }else if(args.opr == 'back'){
        }else if(args.opr == 'play'){
            var scene=args.scene;
            // var ch = args.scene.member[args.player];
            scene.flare("act_console", { value: "call status", args: args });
            // args.tweener
            //     .call(function(_args){

            //     }, null, [args]);
        }
    });    
    April.define("log.power-buff", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
        }else if(args.opr == 'back'){
        }else if(args.opr == 'play'){
            var scene=args.scene;
            var ch = args.scene.member[args.player];
            scene.flare("act_console", { value: "call DisplayComponent/buff.power-up", args: args });
            args.tweener
            .call(function(_args){
                WaveEffect({
                    width:24,height:24,
                }).addChildTo(ch.buffpocket.buffrid[_args.buff]).setPosition(0,0);
            }, null, [args]);
        }
    });
    April.define("DisplayComponent/buff.power-down", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
        }else if(args.opr == 'back'){
        }else if(args.opr == 'play'){
            var scene=args.scene;
            var ch = args.scene.member[args.player];
            scene.flare("act_console", { value: "call DisplayComponent/buff.power-down", args: args });
            args.tweener
            .call(function(_args){
                FlashEffect({
                  width:30,height:30,
                }).addChildTo(ch.buffpocket.buffrid[_args.RID]).setPosition(0,0);
            }, null, [args]);
      }
    });
}
